"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
exports.__esModule = true;
exports.parse = exports.executeScript = exports.checkScript = void 0;
var parser_1 = require("./parser");
function checkScript(script) {
    try {
        (0, parser_1.parse)(script);
        return true;
    }
    catch (e) {
        return false;
    }
}
exports.checkScript = checkScript;
var execute_1 = require("./execute");
__createBinding(exports, execute_1, "default", "executeScript");
var parser_2 = require("./parser");
__createBinding(exports, parser_2, "parse");
